import { computed as t } from "vue";
const i = "regular";
function l(e = {}) {
  const a = t(
    () => e.label ? { "aria-label": e.label } : { "aria-hidden": !0, role: "presentation" }
  );
  return {
    bind: t(() => ({
      width: "1em",
      height: "1em",
      ...a.value
    })),
    weight: t(() => e.weight ?? i)
  };
}
export {
  l as useScalarIcon
};
